import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { otbooking, otbookingData } from '../../../interfaces/OT/ot-booking';
import { otbookingApi } from '../api/ot-booking.api';

@Injectable() 
export class otbookingService extends otbookingData{
 
  constructor(private api: otbookingApi) {
    super();
  } 
  
  getall(url: string): Observable<otbooking[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<otbooking>{
      return this.api.getby_id(url);
  }

  create(url: string, data:otbooking): Observable<otbooking[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:otbooking): Observable<otbooking> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
